"use client";
import { jsx as c } from "react/jsx-runtime";
import { COLOR_SEVERITY as t } from "../../common/constants/colorSeverity.js";
import { css as e } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as o } from "../../tokens/colors/Colors.js";
import { MOTION_EASINGS as d } from "../../tokens/motion-easings/MotionEasings.js";
const l = ({ children: r, ...s }) => /* @__PURE__ */ c(m, { ...s, children: r });
l.displayName = "TableRow";
const m = i.tr(
  ({
    feHighlight: r,
    interactive: s,
    type: b
  }) => {
    const a = (n) => e`
			animation: blink 2s ${d.easeIn};

			@keyframes blink {
				0% {
					background-color: ${n ? o.white : o.gray025};
					box-shadow: none;
				}

				40%,
				60% {
					background-color: ${t.success.light};
					box-shadow: inset 0 0 0 1px ${t.success.base};
				}

				100% {
					background-color: ${n ? o.white : o.gray025};
					box-shadow: none;
				}
			}
		`;
    return e`
			${b === "body" && e`
				${r && a(!1)};
				background: ${o.gray025};

				&:nth-of-type(odd) {
					${r && a(!1)};
					background: ${o.white};
				}

				${s && e`
					&:hover {
						background: rgb(231 238 250);
						box-shadow: inset 0 0 0 1px ${o.brand};
						cursor: pointer;
					}
				`}
			`}
		`;
  }
);
export {
  l as default
};
